'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactSlick = require('react-slick');

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcons = require('@bibliocommons/base-icons');

var _utilsAccessibility = require('@bibliocommons/utils-accessibility');

var _Dots = require('./Dots.component');

var _Dots2 = _interopRequireDefault(_Dots);

var _ExitSlide = require('./ExitSlide.component');

var _ExitSlide2 = _interopRequireDefault(_ExitSlide);

var _Item = require('./Item.component');

var _Item2 = _interopRequireDefault(_Item);

var _RegularArrowButton = require('./RegularArrowButton.component');

var _RegularArrowButton2 = _interopRequireDefault(_RegularArrowButton);

var _TouchArrowButton = require('./TouchArrowButton.component');

var _TouchArrowButton2 = _interopRequireDefault(_TouchArrowButton);

require('../styles/BaseCarousel.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SLIDER_TRANSITION_TIME = 750;
var RESIZE_DEBOUNCE_TIME = 500;

var BaseCarousel = function (_BcReactComponent) {
  _inherits(BaseCarousel, _BcReactComponent);

  function BaseCarousel(props) {
    _classCallCheck(this, BaseCarousel);

    var _this = _possibleConstructorReturn(this, (BaseCarousel.__proto__ || Object.getPrototypeOf(BaseCarousel)).call(this, props));

    _this.bindAll('handleGoToNext', 'handleGoToPrevious', 'handleResize', 'handleSlideChanged', 'handleGoToPage', 'getResponsiveProps');
    _this._items = {};
    _this._pageBoundaries = [];
    _this.state = {
      loading: false,
      currentPage: 0,
      windowWidth: 1200,
      responsiveProps: _this.getResponsiveProps()
    };

    _this.baseSlickSettings = {
      infinite: false,
      afterChange: _this.handleSlideChanged,
      beforeChange: _this.handleSlideWillChange,
      speed: SLIDER_TRANSITION_TIME,
      accessibility: false,
      draggable: false
    };
    return _this;
  }

  _createClass(BaseCarousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', _lodash2.default.debounce(this.handleResize, RESIZE_DEBOUNCE_TIME));
      setTimeout(function () {
        if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
          var evt = document.createEvent('UIEvents');
          evt.initUIEvent('resize', true, false, window, 0);
          window.dispatchEvent(evt);
        } else {
          window.dispatchEvent(new Event('resize'));
        }
      }, 0);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      var settings = this.getSettings();
      var sliderWrapperEl = _reactDom2.default.findDOMNode(this._slider); // eslint-disable-line react/no-find-dom-node
      if (sliderWrapperEl !== undefined && settings.partiallyShowOffscreenItems) {
        var slickListEl = sliderWrapperEl.getElementsByClassName('slick-list');
        if (slickListEl[0] !== undefined && settings.partiallyShowOffscreenItems) {
          slickListEl[0].style.margin = '0 calc(-1.5 * ' + settings.gutterSize + ')';
          slickListEl[0].style.padding = '0 calc(1.5 * ' + settings.gutterSize + ')';
        }
      }
    }
  }, {
    key: 'getBreakpoints',
    value: function getBreakpoints() {
      return Object.keys(this.props.breakpointSettings).map(function (breakPoint) {
        return parseInt(breakPoint, 10);
      }).sort(function (a, b) {
        return a - b;
      });
    }
  }, {
    key: 'getCurrentBreakpoint',
    value: function getCurrentBreakpoint() {
      var width = this.state.windowWidth;
      var breakPoints = this.getBreakpoints();
      for (var i = 0; i < breakPoints.length; i += 1) {
        if (width <= breakPoints[i]) {
          return breakPoints[i];
        }
      }

      return _lodash2.default.last(breakPoints);
    }
  }, {
    key: 'handleGoToPage',
    value: function handleGoToPage(page) {
      var newPage = _lodash2.default.clamp(page, 0, this.getTotalPages());
      if (!this.state.loading && newPage !== this.getCurrentPage()) {
        this.setState({ currentPage: newPage, loading: true });
      }
    }
  }, {
    key: 'getSettings',
    value: function getSettings() {
      var breakPoint = this.getCurrentBreakpoint();
      return this.props.breakpointSettings[breakPoint];
    }
  }, {
    key: 'getResponsiveProps',
    value: function getResponsiveProps() {
      var _this2 = this;

      return _lodash2.default.map(this.props.breakpointSettings, function (v, k) {
        return { breakpoint: parseInt(k, 10), settings: _this2.getSlickProps(v) };
      });
    }
  }, {
    key: 'getSlickProps',
    value: function getSlickProps(settings) {
      return _extends({}, this.baseSlickSettings, {
        dots: false,
        arrows: false,
        slidesToShow: settings.itemsPerPage,
        slidesToScroll: settings.itemsPerPage
      });
    }
  }, {
    key: 'calcPageIndices',
    value: function calcPageIndices() {
      var _getSettings = this.getSettings(),
          itemsPerPage = _getSettings.itemsPerPage;

      var indices = _lodash2.default.times(this.getItemCount(), function (i) {
        return i;
      });
      this._pageBoundaries = _lodash2.default.chain(indices).chunk(itemsPerPage).map(function (chunk) {
        if (chunk.length < itemsPerPage) {
          return _lodash2.default.nth(indices, -1 * itemsPerPage);
        }
        return chunk[0];
      }).value();
    }
  }, {
    key: 'getCurrentPage',
    value: function getCurrentPage() {
      return this.state.currentPage;
    }
  }, {
    key: 'getTotalPages',
    value: function getTotalPages() {
      return Math.ceil(this.getItemCount() / this.getSettings().itemsPerPage);
    }
  }, {
    key: 'handleSlideChanged',
    value: function handleSlideChanged() {
      var _this3 = this;

      this.setState({ loading: false }, function () {
        if (_this3._items[_this3._pageBoundaries[_this3.getCurrentPage()]]) {
          (0, _utilsAccessibility.setFocusWithinElement)(_this3._items[_this3._pageBoundaries[_this3.getCurrentPage()]]);
        }
      });
    }
  }, {
    key: 'handleGoToNext',
    value: function handleGoToNext() {
      var currentPage = this.state.currentPage;
      var newPage = Math.min(currentPage + 1, this.getTotalPages());
      if (!this.state.loading && newPage !== currentPage) {
        this.setState({ currentPage: newPage, loading: true });
      }
    }
  }, {
    key: 'handleGoToPrevious',
    value: function handleGoToPrevious() {
      var currentPage = this.state.currentPage;
      var newPage = Math.max(currentPage - 1, 0);
      if (!this.state.loading && newPage !== currentPage) {
        this.setState({ currentPage: newPage, loading: true });
      }
    }
  }, {
    key: 'handleResize',
    value: function handleResize() {
      var _this4 = this;

      var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.setState({ windowWidth: windowWidth, currentPage: 0 }, function () {
        if (_this4.props.renderExitSlide) {
          var sliderWrapperEl = _reactDom2.default.findDOMNode(_this4._slider); // eslint-disable-line react/no-find-dom-node
          var items = sliderWrapperEl.getElementsByClassName('cp-item');
          var exitSlide = sliderWrapperEl.getElementsByClassName('cp-exit-slide')[0];
          var newHeight = items.length >= 2 ? items[items.length - 2].clientHeight : 1.5 * exitSlide.clientWidth;
          sliderWrapperEl.getElementsByClassName('cp-exit-slide')[0].style.height = newHeight + 'px';
        }
        _this4.calcPageIndices();
        _this4.handleGoToPage(0);
      });
    }
  }, {
    key: 'getItemCount',
    value: function getItemCount() {
      var slideCount = this.props.children ? this.props.children.length : 0;
      if (this.props.renderExitSlide && this.props.titleData.carouselTitleLink) {
        slideCount += 1;
      }
      return slideCount;
    }
  }, {
    key: 'itemIsActive',
    value: function itemIsActive(index) {
      var slidesPerPage = this.getSettings().itemsPerPage;
      var startIndex = this._pageBoundaries[this.state.currentPage] || 0;
      var endIndex = startIndex + slidesPerPage;
      return index >= startIndex && index < endIndex;
    }
  }, {
    key: 'renderItem',
    value: function renderItem(contents, index) {
      var _this5 = this;

      var settings = this.getSettings();

      return _react2.default.createElement(
        'div',
        { key: index, ref: function ref(el) {
            return _this5._items[index] = el;
          } },
        _react2.default.createElement(
          _Item2.default,
          {
            styles: { width: 'calc(100% - ' + settings.gutterSize + ')', margin: '0 auto' },
            hidden: !this.itemIsActive(index) },
          contents
        )
      );
    }
  }, {
    key: 'renderRegularLeftArrow',
    value: function renderRegularLeftArrow() {
      var settings = this.getSettings();
      var numberOfItems = this.getItemCount();

      if (!settings.useTouchArrows) {
        return _react2.default.createElement(_RegularArrowButton2.default, {
          style: { backgroundColor: this.props.buttonBackgroundColor },
          handleClick: this.handleGoToPrevious,
          currentPage: this.getCurrentPage(),
          pageSize: settings.itemsPerPage,
          disabled: this.getCurrentPage() <= 0,
          numberOfItems: numberOfItems,
          direction: 'left' });
      }
      return null;
    }
  }, {
    key: 'renderRegularRightArrow',
    value: function renderRegularRightArrow() {
      var settings = this.getSettings();
      var numberOfItems = this.getItemCount();

      if (!settings.useTouchArrows) {
        return _react2.default.createElement(_RegularArrowButton2.default, {
          style: { backgroundColor: this.props.buttonBackgroundColor },
          handleClick: this.handleGoToNext,
          currentPage: this.getCurrentPage(),
          pageSize: settings.itemsPerPage,
          disabled: this.getCurrentPage() >= this.getTotalPages() - 1,
          numberOfItems: numberOfItems,
          direction: 'right' });
      }

      return null;
    }
  }, {
    key: 'renderTouchArrowButtons',
    value: function renderTouchArrowButtons() {
      var settings = this.getSettings();
      var numberOfItems = this.getItemCount();

      if (settings.useTouchArrows) {
        return _react2.default.createElement(
          'div',
          { className: 'touch-arrows' },
          _react2.default.createElement(_TouchArrowButton2.default, {
            handleClick: this.handleGoToPrevious,
            currentPage: this.getCurrentPage(),
            pageSize: settings.itemsPerPage,
            disabled: this.getCurrentPage() <= 0,
            numberOfItems: numberOfItems,
            direction: 'left' }),
          _react2.default.createElement(_TouchArrowButton2.default, {
            handleClick: this.handleGoToNext,
            currentPage: this.getCurrentPage(),
            pageSize: settings.itemsPerPage,
            disabled: this.getCurrentPage() >= this.getTotalPages() - 1,
            numberOfItems: numberOfItems,
            direction: 'right' })
        );
      }

      return null;
    }
  }, {
    key: 'renderDots',
    value: function renderDots() {
      var settings = this.getSettings();
      if (this.getTotalPages() > 1 && settings.showDots) {
        return _react2.default.createElement(_Dots2.default, {
          currentPage: this.getCurrentPage(),
          pages: this.getTotalPages(),
          pageSize: settings.itemsPerPage,
          numberOfItems: this.getItemCount(),
          handleGoToPage: this.handleGoToPage });
      }

      return null;
    }
  }, {
    key: 'renderCarouselTitle',
    value: function renderCarouselTitle() {
      var settings = this.getSettings();
      var titleData = this.props.titleData;

      if (titleData.carouselTitle) {
        var titleClassName = (0, _classnames2.default)('heading-moderate', {
          'with-touch-arrows': settings.useTouchArrows
        });
        var HeadingTag = titleData.headingTag;
        return _react2.default.createElement(
          HeadingTag,
          { className: titleClassName },
          titleData.carouselTitleLink ? _react2.default.createElement(
            'a',
            { className: 'link-carousel-heading', href: titleData.carouselTitleLink },
            titleData.carouselTitle,
            _react2.default.createElement(_baseIcons.Chevron.Right, { className: 'carousel-heading' })
          ) : titleData.carouselTitle
        );
      }
      return [];
    }
  }, {
    key: 'renderExitSlide',
    value: function renderExitSlide() {
      if (this.props.renderExitSlide && this.props.titleData.carouselTitleLink) {
        var exitLink = _react2.default.createElement(_ExitSlide2.default, { url: this.props.titleData.carouselTitleLink });
        return this.renderItem(exitLink, this.props.children.length, 'empty-link');
      }
      return [];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var children = this.props.children;

      var settings = this.getSettings();
      var classnames = (0, _classnames2.default)('cp-base-carousel', {
        'show-offscreen-items': settings.partiallyShowOffscreenItems
      });
      var wrapperStyles = settings.useTouchArrows ? { width: '100%' } : { width: 'calc(100% + ' + settings.gutterSize + ' - 100px)', margin: '0 calc(-1 * ' + settings.gutterSize + ' / 2)' };

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(el) {
            return _this6._carouselContainer = el;
          },
          className: classnames },
        this.renderCarouselTitle(),
        _react2.default.createElement(
          'div',
          { className: 'slider-with-arrows' },
          this.renderRegularLeftArrow(),
          _react2.default.createElement(
            'div',
            { className: 'slider-wrapper', style: wrapperStyles },
            _react2.default.createElement(
              _reactSlick2.default,
              _extends({}, this.baseSlickSettings, {
                responsive: this.state.responsiveProps,
                slickGoTo: this._pageBoundaries[this.state.currentPage],
                ref: function ref(el) {
                  return _this6._slider = el;
                } }),
              children.map(function (child, index) {
                return _this6.renderItem(child, index);
              }),
              this.renderExitSlide()
            )
          ),
          this.renderRegularRightArrow()
        ),
        this.renderDots(),
        this.renderTouchArrowButtons()
      );
    }
  }]);

  return BaseCarousel;
}(_baseBcReactComponent2.default);

BaseCarousel.propTypes = {
  children: _react.PropTypes.arrayOf(_react.PropTypes.element),
  buttonBackgroundColor: _react.PropTypes.string,
  renderExitSlide: _react.PropTypes.bool,
  breakpointSettings: _react.PropTypes.objectOf(_react.PropTypes.shape({
    useTouchArrows: _react.PropTypes.bool,
    itemsPerPage: _react.PropTypes.number,
    partiallyShowOffscreenItems: _react.PropTypes.bool,
    showDots: _react.PropTypes.bool,
    gutterSize: _react.PropTypes.string
  })),
  titleData: _react.PropTypes.shape({
    headingTag: _react.PropTypes.string,
    carouselTitle: _react.PropTypes.string,
    carouselTitleLink: _react.PropTypes.string
  })
};

BaseCarousel.defaultProps = {
  buttonBackgroundColor: '#fff',
  renderExitSlide: false,
  children: []
};

exports.default = BaseCarousel;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/carousel-base/lib/components/BaseCarousel.component.js
// module id = 1397
// module chunks = 1